export default __webpack_public_path__ + "locales/bg/OAuth.json?hash=7e21e100c785ae33c785f5e330376e82";